import * as React from 'react';

const Search = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.71 19.29L17.31 15.9C18.407 14.502 19.002 12.777 19 11C19 6.582 15.418 3 11 3C6.582 3 3 6.582 3 11C3 15.418 6.582 19 11 19C12.777 19.002 14.502 18.407 15.9 17.31L19.29 20.71C19.679 21.102 20.312 21.105 20.704 20.716L20.71 20.71C21.102 20.321 21.105 19.688 20.716 19.296L20.71 19.29ZM5 11C5 7.686 7.686 5 11 5C14.314 5 17 7.686 17 11C17 14.314 14.314 17 11 17C7.686 17 5 14.314 5 11Z" fill="currentColor"/>
  </svg>
);

export default Search;
